<template>
  <div
    :class="step.className"
    class="br-product-slide__demo">
    <div
      :class="step.className"
      class="br-product-slide__process">
      <div
        v-if="step.title"
        :class="[
          step.className + '__dialog',
          step.dialogClassName
        ]"
        class="br-product-slide__demo__steps">
        <div class="br-product-slide__demo__steps__head">
          <i
            :class="step.icon"
            class="icon"/>
        </div>
        <div class="br-product-slide__demo__steps__body">
          <p><strong>{{ step.title }}</strong></p>
          <p>{{ step.description }}</p>
          <div class="button-group">
            <button
              class="button button--small u-border-radius"
              @click.prevent="$emit('prev')">
              Prev
            </button>
            <button
              class="button button--small u-border-radius"
              @click.prevent="$emit('next')">
              Next
            </button>
          </div>
        </div>
      </div>

      <div
        v-for="(component, index) in step.components"
        :key="index"
        :class="component.className">
        <img :src="component.image">
      </div>

      <div class="br-product-slide__process-f__component-e-label">
        Ideas
      </div>

      <div class="br-product-slide__process-f__component-g-label">
        Questions
      </div>

      <div class="br-product-slide__process-f__component-f-label">
        Tips
      </div>

      <div class="br-product-slide__process-f__component-d-label">
        Resources
      </div>

      <div class="br-product-slide__process-g__tab-marker br-product-slide__process-g__tab-marker--pulsate"/>
    </div>

    <div
      v-if="step.overlayClass"
      :class="step.overlayClass"/>

    <img
      class=""
      :src="step.image">
  </div>
</template>

<script>
export default {
  props: {
    step: {
      type: Object,
      required: true
    }
  }
}
</script>
